import React, { Component } from 'react'

class Clock extends Component {

  constructor(props) {
    super(props);
    this.state = {date: new Date()};
  }

  componentDidMount() {
    this.timerID = setInterval(
      () => this.tick(),
      1000
    );
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  tick() {
    this.setState({
      date: new Date()
    });
  }

  render() {
    return (
      <span>{this.state.date.toLocaleTimeString()}</span>
    )
  }
}

// Show current datetime
//setInterval() //1 second

export default Clock


// WEBPACK FOOTER //
// ./src/components/Header/_Clock.js